<template>
  <b-card
    v-if="statistic"
    no-body
    style="height: 100%"
    class="justify-content-between"
  >
    <b-card-header>
      <h4 class="mb-0">کابران آنلاین</h4>
      <b-card-text class="font-medium-5 mb-0">
        <feather-icon icon="HelpCircleIcon" size="21" class="text-muted" />
      </b-card-text>
    </b-card-header>
    <div v-if="loading">
      <b-skeleton
        class="mx-auto"
        type="avatar"
        width="300px"
        height="300px"
      ></b-skeleton>
    </div>
    <!-- apex chart -->
    <vue-apex-charts
      v-else
      type="radialBar"
      height="320"
      class="  "
      :options="goalOverviewRadialBar"
      :series="statistic.series"
    />
    <b-row class="text-center mx-0">
      <b-col
        cols="6"
        class="border-top border-right d-flex align-items-center flex-column py-1"
      >
        <b-card-text class="text-muted mb-1"> تعداد کل کاربران </b-card-text>
        <b-skeleton v-if="!statistic.completed" width="60px"></b-skeleton>
        <h3 v-else class="font-weight-bolder mb-0">
          {{ statistic.completed }}
        </h3>
      </b-col>

      <b-col
        cols="6"
        class="border-top d-flex align-items-center flex-column py-1"
      >
        <b-card-text class="text-muted mb-1">بازدید امروز</b-card-text>
        <b-skeleton v-if="!statistic.inProgress" width="60px"></b-skeleton>
        <h3 v-else class="font-weight-bolder mb-0">
          {{ statistic.inProgress }}
        </h3>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BRow,
  BCol,
  BCardText,
  BSkeleton,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";

const $strokeColor = "#ebe9f1";
const $textHeadingColor = "#5e5873";
const $goalStrokeColor2 = "#51e5a8";
export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BRow,
    BCardText,
    BCol,
    BSkeleton,
  },

  data() {
    return {
      Progress: {},
      loading: false,

      goalOverviewRadialBar: {
        chart: {
          height: 245,
          type: "radialBar",
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: "77%",
            },
            track: {
              background: $strokeColor,
              strokeWidth: "50%",
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: "2.86rem",
                fontWeight: "600",
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            shadeIntensity: 0.5,
            gradientToColors: [$themeColors.success],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: "round",
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
    };
  },

  computed: {
    statistic() {
      return {
        completed: this.Progress.users,
        inProgress: this.Progress.online,
        series: [
          this.Progress.online &&
            Math.ceil((this.Progress.last_online / this.Progress.online) * 100),
        ],
      };
    },
  },
  created() {
    this.getOnlineUser();
  },
  methods: {
    async getOnlineUser() {
      this.loading = true;
      try {
        const { data } = await this.$http.get("/panel/users/online");
        this.Progress = data.data;
      } catch (e) {}

      this.loading = false;
    },
  },
};
</script>
